import React from "react";
import ProductListPage, { onFilterChange } from '../../components/blocks/ProductListPage/ProductListPage';
import MetaElement from "../../components/elements/MetaElement";
import { readableSearchValue } from '../../utils/misc';

// const { onFilterChange, default: ProductListPage } = require("../../components/blocks/ProductListPage/ProductListPage");


const Cautare = (props) => {
    return (<>
        <MetaElement pageId="cautare/[query]" variables={{
            query: readableSearchValue(props.query)
        }}/>
        <ProductListPage {...props} view="search" key={props.query}></ProductListPage>
    </>)
}

Cautare.getInitialProps = async function(ctx) {
    const query = ctx.query.query;
    const page = ctx.query.page || 1;
    const sort = ctx.query.sort || 'new';
    const sortDirection = ctx.query.sortDirection || 'DESC';

    let arrayFilters = Array.isArray(ctx.query.filters) ? ctx.query.filters : ctx.query.filters ? [ctx.query.filters] : [];

    const filters = (arrayFilters || []).map(filter => {
        let splitFilter = filter.split("_");
        let key = splitFilter[0];
        let values = splitFilter[1].split(";");
        return {
            id: key,
            value: values
        }
    })

    const opts = {
        page: page,
        pageSize: 24,
        search: query,
        sort,
        filters: filters,
        view: "search"
    }

    const response = await onFilterChange(opts);

    return { ...response, page, query, sort, sortDirection, filterState: filters };
}

export default Cautare;
